import { Props as InputProps } from "@storeblocks/input";
import React, { forwardRef } from "react";
import { Additions, InputContainer } from "./styled";

import { StyledStoreblocksInput } from "Components/Form/Input/inputStyled";
import { ThemedSpinner } from "Components/Themes/components/ThemedSpinner";
import { useElementWidth } from "Utils/sizeUtils";

type InputPropsToExclude =
  | "icon"
  | "suffix"
  | "label"
  | "labelProps"
  | "hint"
  | "hintProps"
  | "error"
  | "errorProps"
  | "warning"
  | "warningProps"
  | "success"
  | "successProps";

export interface Props extends Omit<InputProps, InputPropsToExclude> {
  isLoading: boolean;
}

const LoadingInput = forwardRef<HTMLInputElement, Props>(
  ({ id, isLoading, ...rest }: Props, ref): React.ReactElement => {
    const [additionsRefCallback, additionsWidth] = useElementWidth();

    return (
      <InputContainer inputId={id} additionsWidth={additionsWidth ?? 0}>
        <StyledStoreblocksInput id={id} {...rest} ref={ref} />
        <Additions ref={additionsRefCallback}>
          {isLoading && (
            <ThemedSpinner size="small" style={{ marginRight: "16px" }} />
          )}
        </Additions>
      </InputContainer>
    );
  },
);

LoadingInput.displayName = "LoadingInput";

export { LoadingInput };
